import { render, staticRenderFns } from "./CmgPreConfiguredMealCard.vue?vue&type=template&id=b4dd9106&scoped=true&lang=pug&"
import script from "./cmg-preconfigured-meal-card.ts?vue&type=script&lang=ts&"
export * from "./cmg-preconfigured-meal-card.ts?vue&type=script&lang=ts&"
import style0 from "./CmgPreConfiguredMealCard.vue?vue&type=style&index=0&id=b4dd9106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4dd9106",
  null
  
)

export default component.exports